var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"link-base",class:_vm.centered ? 'centered' : null,attrs:{"to":_vm.link}},[_c('p',{staticClass:"text",class:{
      main: _vm.type == 1 || _vm.type == undefined,
      secondary: _vm.type == 2,
      thirdary: _vm.type == 3
    }},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }